import React from "react";
import alerta from "../../assets/alerta.png";

const Section5 = () => {

    return (
        <div className="grid grid-cols-10 bg-[#0346a4] text-white items-center justify-between z-2 relative px-40 py-16 ">
            <div className="col-span-6 ">
                <div>
                    <h2 className="text-4xl font-bold pb-10">¿Quieres dejar de compartir tus datos?</h2>
                    <p className="text-2xl text-[#cfe3fb] text-xl font-bold">Desde MeuBancos en nuestra app, puedes desvincular cualquier banco o entidad.</p>
                    <p className="text-2xl text-[#cfe3fb] py-3 text-xl font-bold">Una vez lo hagas, dejaremos de acceder a nueva información de esa entidad, pero aún podrás ver tu historial de movimientos en Día a Día.</p>
                    <p className="text-2xl text-[#cfe3fb] text-xl font-bold">Al realizar este proceso, Bancolombia dejará de utilizar los datos que autorizaste compartir para cualquier otro propósito.</p>
                </div>
                <div className="mt-10 ">
                    <h2 className="text-4xl font-bold pb-10">Si deseas eliminar por completo el historial de movimientos, sigue estos pasos:</h2>
                    <p className="text-2xl text-[#cfe3fb] ml-10 text-xl font-bold">1. Llama al +57 (601) 343 0000 o al +57 (604) 510 9000</p>
                    <p className="text-2xl text-[#cfe3fb] ml-10 py-3 text-xl font-bold">2. Marca la opción 5 (otras consultas) y la opción 4 (asesoría general).</p>
                    <p className="text-2xl text-[#cfe3fb] ml-10 text-xl font-bold">3. Dile al asesor que deseas revocar tu autorización y eliminar el historial de datos.</p>
                </div>

            </div>

            <div className="col-span-4 flex justify-center">
                <img src={alerta} alt="Alerta" className="w-[50%] h-auto" />
            </div>
        </div>


    );
};

export default Section5;
